// @flow
import * as React from 'react'
import PrimaryButton from 'ui/PrimaryButton'
import SearchBar from 'ui/SearchBar'

type Props = {
  onCreateExport: () => void,
}

function ExportsPageHeader({ onCreateExport }: Props): React.Node {
  return (
    <div className="sm:flex">
      <div className=" max-w-screen-xl mx-auto md:px-3 md:pl-0 form-dropdown">
        <div className="sm:flex sm:space-x-4">
          <PrimaryButton className="mb-4" onClick={onCreateExport}>
            Create Export
          </PrimaryButton>
        </div>
      </div>
      <SearchBar className="flex-1 mb-4" />
    </div>
  )
}

export default ExportsPageHeader
